import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as feedbackAPI from 'api/FeedBack';
import { openSnackbar } from 'store/reducers/snackbar';

const initialState = {
  feedbackData: {
    count: 0,
    next: true,
    previous: null,
    results: []
  },
  feedBackConfigData: null,
  SearchData: null,
  FeedBackListIdData: null,
  AddFeedBackData: null,
  AddFeedBackModalData: null,
  rangeDate: null,
  Status: null,
  Priority: null,
  Agent: null,
  conversation: null,
  FeedBackFilterData: null,
  FeedBackFilters: null,
  UpdateFeedBackStatusData: null,
  id: null,
  pagination: {
    pageSize: 15,
    page: 1
  },
  ui: {
    loading: false
  },
  error: null,
  status: 'init'
};

const getFeedBackState = (state) => state.feedback;

const getFeedBackConfigData = createAsyncThunk('feedback/getFeedBackConfigData', async (_, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.getFeedBackConfigData();
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getFeedBackData = createAsyncThunk('feedback/getFeedBackData', async ({ signal, ...params }, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.getFeedBackData(params, signal);
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getSearchData = createAsyncThunk('feedback/getSearchData', async ({ signal, ...params }, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.getSearchData(params, signal);
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getFeedBackIdData = createAsyncThunk('feedback/getFeedBackIdData', async (id, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.getFeedBackIdData({ id });
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
const getConversationData = createAsyncThunk('feedback/getConversationData', async (id, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.getConversationData({ id });
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const addFeedbackData = createAsyncThunk('feedback/addFeedbackData', async (params, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.addFeedbackData(params);
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const addFeedBackModalData = createAsyncThunk('feedback/addFeedBackModalData', async (params, { dispatch, rejectWithValue }) => {
  try {
    const { feedback_part, audio_part } = params;
    console.log('decontruct', feedback_part, audio_part);
    const res = await feedbackAPI.addFeedBackModalData(feedback_part);
    const id = res.data?.data?.id;
    let data = {};
    audio_part.forEach((item, index) => {
      data[`data[${index}][feedback]`] = id;
      data[`data[${index}][file_path]`] = item.file;
    });
    console.log('formData in api call', id, data);
    // console.log('res from modal', res?.data?.data);
    const postAudioRes = await feedbackAPI.addFeedModalDataAudioFiles(data);
    dispatch(
      openSnackbar({
        open: true,
        message: res.data?.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: false
      })
    );
    console.log('audio res', postAudioRes);
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getFeedBackFilterData = createAsyncThunk('feedback/getFeedBackFilterData', async ({ signal, ...params }, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.getFeedBackFilterData(params, signal);
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const updateFeedBackStatus = createAsyncThunk('feedback/updateFeedBackStatus', async ({ signal, ...params }, { rejectWithValue }) => {
  try {
    const res = await feedbackAPI.updateFeedBackStatus(params, signal);
    return res.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const feddBackSlice = createSlice({
  name: 'feedback',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    selectedid: (state, action) => {
      state.id = action.payload;
    },
    setPaginationData: (state, action) => {
      state.pagination.page = action.payload;
    },
    setUpdateFeedback: (state, action) => {
      state?.feedbackData?.results?.map((item) => {
        if (item.id === action.payload.feedback_id) {
          item.feedback_list_part_status = action.payload.feedback_activity_status;
        }
      });
    },
    removeFeedbackData: (state) => {
      state.feedbackData.results = [];
    },
    setFeedBackFilters: (state, action) => {
      state.FeedBackFilters = action.payload;
    }
  },

  extraReducers: {
    [getFeedBackConfigData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getFeedBackConfigData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.feedBackConfigData = action.payload;
      state.rangeDate = action.payload?.select_date?.value;
      state.Status = action.payload?.status?.value;
      state.Priority = action.payload?.priority?.value;
      state.Agent = action.payload?.select_agent?.value;
    },

    [getFeedBackConfigData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getFeedBackData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getFeedBackData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      // Assuming that `action.payload` contains the new data
      const { results, ...others } = action.payload;
      state.feedbackData = {
        ...state.feedbackData,
        results: [...state.feedbackData.results, ...results],
        ...others
      };

      state.pagination.page = state.pagination.page + 1;
    },

    [getFeedBackData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getSearchData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getSearchData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.SearchData = action.payload;
    },

    [getSearchData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getFeedBackIdData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getFeedBackIdData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.FeedBackListIdData = action.payload;
    },

    [getFeedBackIdData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getConversationData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getConversationData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.conversation = action.payload;
    },

    [getConversationData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [addFeedbackData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [addFeedbackData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.AddFeedBackData = action.payload;
    },

    [addFeedbackData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [addFeedBackModalData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [addFeedBackModalData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.error = false;
      state.AddFeedBackModalData = action.payload;
    },

    [addFeedBackModalData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getFeedBackFilterData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getFeedBackFilterData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.feedbackData = action.payload;
    },

    [getFeedBackFilterData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [updateFeedBackStatus.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [updateFeedBackStatus.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.UpdateFeedBackStatusData = action.payload;
    },

    [updateFeedBackStatus.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

export const { resetState, selectedid, setPaginationData, setUpdateFeedback, removeFeedbackData, setFeedBackFilters } =
  feddBackSlice.actions;

export default feddBackSlice.reducer;

export {
  getFeedBackState,
  getFeedBackConfigData,
  getFeedBackData,
  getSearchData,
  getFeedBackIdData,
  getConversationData,
  addFeedbackData,
  addFeedBackModalData,
  getFeedBackFilterData,
  updateFeedBackStatus
};
